import React from 'react';

function About() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">About How To Bachelor</h1>
      </div>

      <div className="page-body">
        <p>
          Welcome to <strong>How To Bachelor</strong> - your comprehensive guide to thriving in bachelor life.
          Whether you're living on your own for the first time or looking to level up your independent lifestyle,
          we're here to help.
        </p>

        <h2>Our Mission</h2>
        <p>
          We believe that bachelor living shouldn't mean sacrificing your health, happiness, or home-cooked meals.
          Our mission is to provide practical, no-nonsense advice that helps men live their best lives independently.
        </p>

        <h2>What We Cover</h2>
        <p>
          Our content focuses on four key areas that are essential to bachelor living:
        </p>

        <h3>🧠 Mental Health</h3>
        <p>
          From managing stress and building better sleep habits to creating daily routines that support your wellbeing,
          we provide practical mental health advice tailored for bachelors.
        </p>

        <h3>💡 Life Tips</h3>
        <p>
          Master the everyday skills you need - from doing laundry and cleaning your space to managing your time
          and organizing your life. We break down life's essential tasks into simple, actionable steps.
        </p>

        <h3>🍳 Quick Recipes</h3>
        <p>
          No need for complicated recipes or expensive ingredients. We share quick, easy meals that actually taste
          good and won't break your budget. Perfect for busy schedules and minimal cooking experience.
        </p>

        <h3>🎯 Hobby Kits</h3>
        <p>
          Discover new interests and passions with our hobby starter guides. From home brewing to woodworking,
          we help you get started with hobbies that enrich your life and give you something to look forward to.
        </p>

        <h2>Our Philosophy</h2>
        <p>
          Think of us as your favorite barbershop - a welcoming space where you can get straight talk,
          practical advice, and genuine support. We keep things relaxed, real, and focused on what actually works.
        </p>

        <p>
          We're not here to judge or lecture. We're here to share knowledge, build community, and help you
          create a bachelor lifestyle you're proud of.
        </p>

        <h2>Get In Touch</h2>
        <p>
          Have questions, suggestions, or topics you'd like us to cover? We'd love to hear from you!
          Connect with us on social media or drop us a line.
        </p>

        <p style={{ marginTop: '3rem', textAlign: 'center', fontSize: '1.5rem' }}>
          Welcome to the barbershop. Pull up a chair. ✂️
        </p>
      </div>
    </div>
  );
}

export default About;
